module.exports = __webpack_public_path__ + "img/ferratumbusinessflex.fb4d3ef.png";